import { FilterList } from "@mui/icons-material";
import { Box, Button, MenuItem, Select, Slider, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomDrawer from './Drawer';

const Filters = ({ categories = [], values: { name, category, rangePrices }, onClearFilters, onApplyFilters, loading, width = 300 }) => {
  const [categoryLocal, setCategoryLocal] = useState(category);
  const [priceRange, setPriceRange] = useState(rangePrices);
  const [nameLocal, setNameLocal] = useState(name ? name : '');

  const handlePriceChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const handleCategoryChange = (event) => {
    setCategoryLocal(event.target.value);
  };

  const handleClearFilters = () => {
    setNameLocal('')
    setCategoryLocal('')
    onClearFilters && onClearFilters()
  }

  const handleApplyFilters = () => {
    onApplyFilters && onApplyFilters({ name: nameLocal, category: categoryLocal, rangePrices: priceRange })
  }

  return (<div style={{ width: width, padding: "20px" }}>
    {/* {loading && <CircularProgress sx={{justifyContent: 'center'}}/>} */}
    {<Box>
      <Typography variant="h6" gutterBottom>
        Filtrar resultados
      </Typography>

      {/* Búsqueda por texto */}
      <TextField disabled={loading} fullWidth label="Buscar" variant="outlined" margin="normal" onChange={(value) => setNameLocal(value.target.value)} value={nameLocal} />

      {/* Categorías (Select) */}
      <Select
        fullWidth
        value={categoryLocal}
        onChange={handleCategoryChange}
        displayEmpty
        variant="outlined"
        disabled={loading}
      >
        {categories?.map(({ _id, type, name }) => (
          <MenuItem id={_id} value={type}><em>{name}</em></MenuItem>
        ))}
      </Select>

      {/* Rango de precios (Slider) */}
      <Box display={'flex'} flexDirection={'column'}>
        <Typography variant="overline" paddingBottom={5}>Rango de precio</Typography>
        <Slider
          value={priceRange}
          onChange={handlePriceChange}
          min={rangePrices[0]}
          max={rangePrices[1]}
          valueLabelDisplay="on"
          disabled={loading}
        />
      </Box>
      {/* Checkboxes */}
      {/* <FormControlLabel control={<Checkbox />} label="Opción 1" />
    <FormControlLabel control={<Checkbox />} label="Opción 2" /> */}

      {/* Botones */}
      <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
        <Button color="error" onClick={handleClearFilters} disabled={loading}>Limpiar</Button>
        <Button color="success" onClick={handleApplyFilters} disabled={loading}>Aplicar</Button>
      </div>
    </Box>}
  </div>)
}

const FilterPanel = ({ open, toggleDrawer, categories = [], filterValues, onClear, onApply, isDrawer = true, loading, width = 250 }) => {
  //const initialFilters = { name: '', category: '', rangePrices: [rangePrices.minPrice, rangePrices.maxPrice]}

  const [filters, setFilters] = useState(filterValues);
  //const [priceRange, setPriceRange] = useState([20, 50]);

  // const handleCategoryChange = (event) => {
  //   setCategory(event.target.value);
  // };

  // const handlePriceChange = (event, newValue) => {
  //   setPriceRange(newValue);
  // };

  const style = { width: width, height: '100%', background: 'background.default' }

  const clearFilters = () => {
    onClear && onClear()
  }

  useEffect(() => {
    setFilters(filterValues)
  }, [filterValues])

  return (
    // <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
    //   <div style={{ width: 300, padding: "20px" }}>
    //     vaicio
    //   </div>
    // </Drawer>
    isDrawer ? <CustomDrawer
      open={open}
      anchor="right"
      style={style}
      isDefault={false}
      listItems={<Filters categories={categories} values={filters} onClearFilters={clearFilters} onApplyFilters={onApply} loading={loading}/>}
      tittle={'Filtros'}
      icon={<FilterList />}
    /> : <Filters categories={categories} values={filters} onClearFilters={clearFilters} onApplyFilters={onApply} loading={loading} width={width}/>
  )
};

export default FilterPanel;
